import React from "react";
import { Link } from "react-router-dom";
import {
  InfoMedia,
  Widget,
  AboutWidget,
  CategoryWidget,
  // RecentPostWidget,
  IconLink,
} from "../../components/";

// Widget Datas
import widgetsdata from "../../data/widgets.json";

const {
  pageList,
  exploreLinks,
  //  recentPosts,
  gst,
} = widgetsdata;

const FooterOne = () => (
  <footer
    className="footer-wrapper footer-layout1 background-image"
    style={{ backgroundImage: "url(images/shape/bg-footer-1-1.jpg)" }}
  >
    <div className="footer-top">
      <div className="container">
        <div className="row">
          <div className="footer-media col-sm">
            <InfoMedia
              icon="fal fa-map-marker-alt"
              title="Office Address"
              info="1st floor adonai tower opp to highland hospital falnir road, Manglore 575002"
            />
          </div>
          <div className="footer-media col-sm">
            <InfoMedia
              icon="fal fa-clock"
              title="Working Hours"
              info="Weekdays 9am - 6pm Weekend 10am - 12pm"
            />
          </div>
          <div className="footer-media col-sm">
            <InfoMedia
              icon="fal fa-phone-volume"
              title="Contact Us"
              info={
                <>
                  <a href="mailto:contact@hpfmarine.com">
                    contact@hpfmarine.com
                  </a>
                  <br />
                  <a href="tel:+917992999966">+91 7992999966</a>
                </>
              }
            />
          </div>
        </div>
      </div>
    </div>
    <div className="widget-area">
      <div className="container">
        <div className="row justify-content-between">
          <div className="col-md-6 col-xl-auto">
            <Widget widgetTitle="About Us" className="footer-widget">
              <AboutWidget>
                <AboutWidget.Text>
                  Discover the pure essence of the ocean with our premium fish
                  oil and fish powder
                </AboutWidget.Text>
                <IconLink className="footer-social">
                  <IconLink.Item
                    icon="fab fa-facebook-f"
                    path="https://www.facebook.com/share/L8bsohB6oS9N3j1n/?mibextid=LQQJ4d"
                  />
                  {/* <IconLink.Item icon="fab fa-twitter" path="/" /> */}
                  {/* <IconLink.Item icon="fab fa-behance" path="/" /> */}
                  <IconLink.Item icon="fab fa-youtube" path="/" />
                  <IconLink.Item
                    icon="fab fa-instagram"
                    path="https://www.instagram.com/hpf_marineline?igsh=MWs4Mjd5MWNnYXhrZw=="
                  />
                </IconLink>
              </AboutWidget>
            </Widget>
          </div>
          <div className="col-6 col-xl-auto">
            <Widget
              widgetTitle="Links"
              className="widget_nav_menu footer-widget"
            >
              <CategoryWidget>
                {pageList.map((cat) => (
                  <CategoryWidget.Item key={cat.name} path={cat.path}>
                    {cat.name}
                  </CategoryWidget.Item>
                ))}
              </CategoryWidget>
            </Widget>
          </div>
          <div className="col-6 col-xl-auto">
            <Widget
              widgetTitle="Explore"
              className="widget_nav_menu footer-widget"
            >
              <CategoryWidget>
                {exploreLinks.map((cat) => (
                  <CategoryWidget.Item key={cat.name} path={cat.path}>
                    {cat.name}
                  </CategoryWidget.Item>
                ))}
              </CategoryWidget>
            </Widget>
          </div>
          <div className="col-md-6 col-xl-auto">
            <Widget
              widgetTitle="GSTIN : 29AAHCH5206R1ZZ"
              className="widget_nav_menu footer-widget"
              style={{ fontWeight: "normal" }}
            >
              <CategoryWidget>
                {gst.map((cat) => (
                  <CategoryWidget.Item key={cat.name} path={cat.path}>
                    {cat.name}
                  </CategoryWidget.Item>
                ))}
              </CategoryWidget>
            </Widget>
          </div>
        </div>
      </div>
    </div>
    <div className="copyright-wrap">
      <div className="container">
        <p className="copyright-text">
          Copyright <i className="fal fa-copyright" /> 2024{" "}
          <Link className="text-white" to="/">
            HPF Marine Line
          </Link>
          . All rights reserved by{" "}
          <a className="text-white" href="https://kliffto.com/">
            Kliffto
          </a>
          .
        </p>
      </div>
    </div>
  </footer>
);

export default FooterOne;
